<template>
	<div v-if="isLoaded" class="receive-awards"
		:style="{ 
			background: data.areaBackgroundColor,
			height: data.areaHeightRatio ? data.areaHeightRatio * 375 + 'px' : 'auto'
		}">
		<div class="receive-awards-title" :style="{ color: data.areaTitleColor, fontSize: (data.areaTitleSize ) / 16 + 'rem' }">
			<span v-if="data.areaTitleLine !== 2" class="content-before" :style="{ borderImage: `linear-gradient(45deg, rgba(255, 196, 137, 0), ${data.areaTitleLineColor || '#FFE2C4'}) 1 1` }"></span>
			<span>{{ data.areaTitle }}</span>
			<span v-if="data.areaTitleLine !== 2" class="content-after" :style="{ borderImage: `linear-gradient(225deg, rgba(255, 196, 137, 0), ${data.areaTitleLineColor || '#FFE2C4'}) 1 1` }"></span>
		</div>

		<div class="receive-awards-img" v-for="(item, index) in showAwardList" :key="index" @click="handleClickImg(item)">
			<!-- 配置的图片 -->
			<div v-if="!item.isConfigWord">
				<div v-if="item.imgPrizeStyle === 2" class="img-prize-big">
					<img :src="item.showImg || item.priceImg" />
					<div class="img-btn" :class="item.showMask && 'img-mask'" :style="{ background: item.prizeBtnColor, color: item.prizeContentColor }">{{ getBtnContent(item) }}</div>
				</div>
				<div v-else class="img-prize-small">
					<img :src="item.showImg || item.priceImg" />
					<div class="img-btn" :class="item.showMask && 'img-mask'" :style="{ background: item.prizeBtnColor, color: item.prizeContentColor }">{{ getBtnContent(item) }}</div>
				</div>
			</div>
			<!-- 配置的文案 -->
			<div v-else-if="item.isConfigWord">
				<!-- 判断奖品样式 -->
				<div v-if="item.priceStyle === 1" class="prize-small" :style="{ background: item.prizeBackgroundColor }">
					<div class="prize-small-left" :class="item.prizeItems.length > 4 && 'left-long'">
						<span v-if="item.isShowMoneyIcon" class="icon" :style="{ color: item.prizeItemsColor }">¥</span>
						<span v-if="item.prizeItems" class="item" :class="item.prizeItems.length > 4 && 'item-long'"
							:style="{ color: item.prizeItemsColor }">{{ item.prizeItems }}</span>
					</div>
					<div class="prize-small-content">
						<p v-if="item.prizeTitle" class="title" :style="{ color: item.prizeTitleColor }">{{ item.prizeTitle }}</p>
						<p v-if="item.prizeDesc" class="desc">{{ item.prizeDesc }}</p>
					</div>
					<div class="prize-small-btn" :class="item.showMask && 'img-mask'" :style="{ background: item.prizeBtnColor, color: item.prizeContentColor }">{{ getBtnContent(item) }}</div>
				</div>
				<div v-else-if="item.priceStyle === 2" class="prize-big" :style="{ background: item.prizeBackgroundColor }">
					<p class="prize-big-desc" :style="{ color: item.prizeTitleColor }">{{ item.prizeDesc }}({{ item.prizeTitle }})</p>
					<p class="prize-big-item" :style="{ color: item.prizeItemsColor }"><span v-if="item.isShowMoneyIcon"
							class="icon">¥</span><span v-if="item.prizeItems" class="item">{{ item.prizeItems }}</span></p>
					<div class="prize-big-btn" :class="item.showMask && 'img-mask'" :style="{ background: item.prizeBtnColor, color: item.prizeContentColor }">{{ getBtnContent(item) }}</div>
				</div>
			</div>
		</div>

		<!-- 规则定位到页面右上角 -->
		<div class="pos-rule" @click="handleClickRule">规则</div>
		<!-- 规则弹窗 -->
		<div v-if="showRulePopup" class="pop-box">
			<div class="rule-pop-box">
				<div class="rule-content">
					<p class="rule-content-title">活动规则</p>
					<div class="rule-content-content"><p></p>{{ data.ruleContent }}</div>
					<div class="rule-close" @click="handleCloseClick">
						<div class="rule-close-content">我知道了</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 来晚了 && 不满足分群弹窗 -->
		<div v-if="showInterceptPopup" class="pop-box">
			<div class="late-pop-box">
				<div class="late-title" :class="notSatisfyGroup && 'not-satisfy-title'"></div>
				<p class="late-content">更多优惠活动请关注好分期APP首页！</p>
				<div class="late-close" @click="handleCloseClick">返回</div>
			</div>
		</div>
		<!-- 领取优惠券弹窗 配置金额版 -->
		<div v-if="showObtainPopup" class="pop-box">
			<div class="obtain-pop-box">
				<div class="obtain-content">
					<div class="obtain-content-title">恭喜您获得优惠券</div>
					<div class="obtain-content-content">
						<div v-for="(obtainItem, obtainIndex) in obtainList" :key="obtainIndex" class="prize-small"
							:class="!obtainItem.isConfigWord && 'prize-small-word'"
							:style="{ background: obtainItem.prizeBackgroundColor || '#FFF2E7' }">
							<div v-if="obtainItem.isConfigWord" class="prize-small-left">
								<span v-if="obtainItem.isShowMoneyIcon" class="icon"
									:style="{ color: obtainItem.prizeItemsColor }">¥</span>
								<span v-if="obtainItem.prizeItems" class="item"
									:class="obtainItem.prizeItems.length > 4 && 'item-long'"
									:style="{ color: obtainItem.prizeItemsColor }">{{ obtainItem.prizeItems }}</span>
							</div>
							<div v-if="obtainItem.isConfigWord" class="prize-small-content">
								<p v-if="obtainItem.prizeTitle" class="title">{{ obtainItem.prizeTitle }}</p>
								<p v-if="obtainItem.prizeDesc" class="desc">{{ obtainItem.prizeDesc }}</p>
							</div>
							<div v-if="!obtainItem.isConfigWord">
								<span class="left-world" v-html="obtainItem.winPrizeTips"></span>
							</div>
						</div>
					</div>
					<div class="obtain-content-btn">
						<p @click="jumpConfigPage()">
							马上借款 立享优惠
							<span v-if="otherConfig.switchAutoJump">(<span class="btn-time">{{ otherConfig.jumpCountDown
									}}</span>s)</span>
						</p>
					</div>
				</div>
				<div v-if="otherConfig.isShowCloseBtn === 1" class="obtain-close" @click="handleCloseClick"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { post } from "../common/http";
import createMessage from './Toast/index.js'
import clientUtil from "../common/clientUtil";
import { getUrlParam, sensorsBuriedPoint } from '../common/util';

export default {
	data() {
		return {
			uid: "00",
			pageId: 0,
			showInterceptPopup: false, // 展示弹窗
			notSatisfyGroup: false, // 不满足用户分群
			showAwardList: [], // 展示的优惠券配置列表
			action: "pageShow", // 页面展示
			showRulePopup: true, // 展示规则弹窗
			showObtainPopup: false, // 展示领取成功弹窗，配置金额版
			winPrizeTips: "", // 领取成功弹窗文案
			groupName: "", // 用户分群名称
			prizeIDList: [],  // 关联奖品ID组成的清单
			canReceiveCoupon: true, // 是否可以领取优惠券
			isLoaded: false, // 页面是否可以渲染
			sensorsPrizeID: "",
			otherConfig: {}, // 页面其他配置项
			obtainList: [], // 领取成功的优惠券
			receivedJumpLink: '', // 领取成功后要跳转的页面地址
		};
	},
	props: {
		data: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	computed: {
		// 判断页面应该展示的奖品图片
		showPrizeList() {
			// 没有开启AB测 data.prizeList
			if (!this.data.switchTest) {
				return this.data.prizeList;
			}
			// 开始AB测 通过uid倒数第二位判断是A分组还是B分组 data.prizeListA data.prizeListB
			const tmpRatioA = this.data.prizeListA.crowdRatio / 10;
			if (this.uid.substr(-2, 1) < tmpRatioA) {
				return this.data.prizeListA;
			}
			return this.data.prizeListB;
		},
		abGroup() {
			if (!this.data.switchTest) return "未分组";
			const tmpRatioA = this.data.prizeListA.crowdRatio / 10;
			return this.uid.substr(-2, 1) < tmpRatioA ? "A分组" : "B分组";
		}
	},
	mounted() {
		this.pageId = sessionStorage.getItem("pageId");
		if (!this.pageId) return;
		// 获取活动配置信息
		this.getActivityConfigInfo();
	},
	methods: {
		getBtnContent(item) {
			return item.isReceived ? '去使用' : (item.prizeBtnContent || '立即领取');
		},
		// 埋点公共属性
		formatSensorData(data) {
      return {
				ActivityID: this.pageId,
        ActivityName: sessionStorage.getItem("pageName") || "",
        Source: getUrlParam("from") || "",
				UserGroupName: this.groupName,
				ABGroup: this.abGroup,
				...data
			}
    },
		// 点击图片判断 领取状态
		// 已领取 跳转优惠券页面
		// 未领取 领取优惠券 展示领取成功弹窗
		async handleClickImg(item, type = 0) {
			console.log("点击的优惠券信息", item);
			// 置灰的优惠券不可点击
			if (item.showMask || !this.canReceiveCoupon) {
				return;
			}
			// 获取优惠券信息
			if (item.isReceived) {
				// 跳转优惠券页面
				console.log("跳转优惠券页面");
				this.receivedJumpLink = item.receiveJumpUrl || "hfqdl://couponList.com?needLogin=1";
				this.jumpCouponPage("活动页", item.relatedPrizeID);
				return;
			}
			this.canReceiveCoupon = false;
			sensorsBuriedPoint("ReceiveAwardClick", this.formatSensorData({ PrizeID: [item.relatedPrizeID], AwardReceivingRethod: type }));
			const couponInfo = await post("/api/v1/coupon/sendCouponById", { _id: item.relatedPrizeID, activityId: this.pageId });
			this.canReceiveCoupon = true;
			if (couponInfo.code === 0 && couponInfo.data === 1) {
				// 奖品发放结果点位 发送成功
				sensorsBuriedPoint("GrantAwardResult", this.formatSensorData({ IsSucess: 1, PrizeID: [item.relatedPrizeID], AwardReceivingRethod: type }));
				if (!type) {
					// 手动领取成功，弹出成功弹窗
					this.obtainList = []; // 先清空
					this.obtainList.push(item);
					this.showObtainPopup = true;
					this.handleTime();
					this.receivedJumpLink = item.receiveJumpUrl || "hfqdl://couponList.com?needLogin=1";
					this.sensorsPrizeID = item.relatedPrizeID; // 埋点使用
					sensorsBuriedPoint("AwardHintPop", this.formatSensorData({ PrizeID: [item.relatedPrizeID] }));
					this.winPrizeTips = item.winPrizeTips;
				} else {
					this.obtainList.push(item);
				}
				this.action = "receive";
				// 获取活动配置信息
				this.getActivityConfigInfo();
			} else {
				!type && createMessage({
					text: '领取失败啦，请稍后再试',
					timeout: 2000
				});
				// 奖品发放结果点位 发送失败
				sensorsBuriedPoint("GrantAwardResult", this.formatSensorData({ IsSucess: 0, PrizeID: [item.relatedPrizeID], FailReason: '', AwardReceivingRethod: type }));
			}
		},
		jumpCouponPage(position = "弹窗", prizeId = '') {
			const PrizeID = prizeId || this.sensorsPrizeID;
			sensorsBuriedPoint("UseAwardClick", this.formatSensorData({ ButtonLocation: position, PrizeID: [ PrizeID ] }));
			console.log('页面跳转地址', this.receivedJumpLink);
			clientUtil.openNewWebPage({
				pageUrl: this.receivedJumpLink
			});
			this.showObtainPopup = false;
		},
		jumpConfigPage() {
			sensorsBuriedPoint("UseAwardClick", this.formatSensorData({ ButtonLocation: "弹窗", PrizeID: [ this.sensorsPrizeID ] }));
			const pageUrl = this.otherConfig.switchAutoJump ? this.otherConfig.jumpPageUrl : this.receivedJumpLink;
			console.log('弹窗跳转地址', pageUrl);
			clientUtil.openNewWebPage({
				pageUrl
			});
			clearInterval(this.timer); // 清除定时器
			this.showObtainPopup = false;
		},
		// 获取活动配置信息
		async getActivityConfigInfo() {
			try {
				const info = await post("/api/v1/landingPage/getActivityConfig", { pageId: this.pageId, action: this.action });
				console.log('活动配置信息', info);
				const { code, data } = info;
				if (code === 0) {
					this.showInterceptPopup = data.showPopup;
					this.showAwardList = data.showAwardList || this.showPrizeList.prizeDetail;
					this.notSatisfyGroup = data.notSatisfyGroup || false;
					this.showRulePopup = false;
					this.otherConfig = data.otherParams || {};
					// 埋点
					if (this.action === "pageShow") {
						this.groupName = data.groupName || this.data.selectedUserGroupName;
						this.uid = data.uid || "00";
						this.showAwardList.map(item => {
							this.prizeIDList.push(item.relatedPrizeID);
						})
						sensorsBuriedPoint("ActivityPageView", this.formatSensorData({ PrizeID: this.prizeIDList, iSmitake: !this.showInterceptPopup }));
						// 判断是否需要自动领券
						this.otherConfig.switchAutoReceive && this.judgeNeedAutoGet();
					}
				}
			} catch (error) {
				console.log(error);
				this.showAwardList = this.showPrizeList.prizeDetail;
				this.canReceiveCoupon = false;
				this.showRulePopup = false;
			}
			this.isLoaded = true;
		},
		// 判断是否需要自动领券
		async judgeNeedAutoGet() {
			// 过滤自动领取的券 配置为自动领取、未领取过、且可领取
			const autoCouponList = this.showAwardList.filter(item => item.isAutoReceive && !item.isReceived && !item.showMask);
			for (let index = 0; index < autoCouponList.length; index++) {
				await this.handleClickImg(autoCouponList[index], 1);
			}
			// 展示弹窗，开启倒计时
			if (this.obtainList.length) {
				this.showObtainPopup = true;
				this.handleTime();
			}
		},
		handleTime() {
			// 领取后自动跳转开关打开处理后续逻辑
			if (!this.otherConfig.switchAutoJump) return;
			if (!this.timer) {
				this.timer = setInterval(() => {
					if (this.otherConfig.jumpCountDown > 1) {
						this.otherConfig.jumpCountDown--;
					} else {
						clearInterval(this.timer);
						this.timer = null;
						this.otherConfig.jumpCountDown = 0;
						console.log('倒计时结束，自动跳转页面', this.otherConfig.jumpPageUrl);
						// 跳转地址
						clientUtil.openNewWebPage({
							pageUrl: this.otherConfig.jumpPageUrl
						});
						// 关闭弹窗
						this.showObtainPopup = false;
					}
				}, 1000);
			}
		},
		// 展示规则弹窗
		handleClickRule() {
			this.showRulePopup = true;
			this.stop();
		},
		// 点击关闭当前页面
		handleCloseClick() {
			this.move();
			if (this.showRulePopup) {
				// 关闭规则弹窗
				this.showRulePopup = false;
				return;
			}
			if (this.showObtainPopup) {
				this.showObtainPopup = false;
				clearInterval(this.timer); // 清除定时器
				return;
			}
			clientUtil.closePage();
		},
		prevent(e) {
      e.preventDefault();
    },
    /** *滑动限制** */
    stop() {
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', this.prevent, false); // 禁止页面滑动
    },
    /** *取消滑动限制** */
    move() {
      document.body.style.overflow = ''; // 出现滚动条
      document.removeEventListener('touchmove', this.prevent, false);
    },
	},
	beforeDestroy() {
    this.move();
  }
};
</script>

<style lang="less" scoped>
.receive-awards {
	box-shadow: 0px 2px 14px 0px rgba(245, 88, 57, 0.08);
	border-radius: 15px 15px 0 0;
	padding-top: 17px;
	padding-bottom: 13px;
	text-align: center;
	&-title {
		display: inline-block;
		font-size: 18px;
		font-family: PingFang SC;
		color: #FFE2C4;
		margin-bottom: 12px;
		.content-before {
			position: relative;
			display: inline-block;
			content: "";
			width: 81px;
			border: 1px solid;
			margin-right: 18px;
			top: -4px;
		}
		.content-after {
			position: relative;
			display: inline-block;
			content: "";
			width: 81px;
			border: 1px solid;
			margin-left: 18px;
			top: -4px;
		}
		span {
			font-weight: bold;
		}
	}
	&-img {
		position: relative;
		margin: 10px 13px;
		.img-prize-big {
			position: relative;
			height: 196px;
			border-radius: 8px;
			img {
				overflow: hidden;
				width: 100%;
				height: 100%;
				vertical-align: middle;
			}
			.img-btn {
				position: absolute;
				z-index: 1;
				bottom: 28px;
				left: 22px;
				width: calc(100% - 44px);
				height: 50px;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 18px;
				color: #FFFFFF;
				line-height: 50px;
				border-radius: 24px;
				background: #FF3838;
			}
			.img-mask {
				opacity: 0.65;
			}
		}
		.img-prize-small {
			height: 92px;
			border-radius: 8px;
			img {
				overflow: hidden;
				width: 100%;
				height: 100%;
				vertical-align: middle;
			}
			.img-btn {
				position: absolute;
				z-index: 1;
				top: 28px;
				right: 24px;
				width: 86px;
				height: 36px;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 36px;
				border-radius: 24px;
				background: #FF3838;
			}
			.img-mask {
				opacity: 0.65;
			}
		}
		.prize-small {
			position: relative;
			display: flex;
			align-items: center;
			padding-right: 24px;
			height: 98px;
			border-radius: 8px;
			&-left {
				width: 104px;
				text-align: left;
				padding-left: 19px;
				.icon {
					width: 10px;
					height: 17px;
					font-family: PingFangSC, PingFang SC;
					font-weight: bold;
					font-size: 16px;
					line-height: 17px;
				}
				.item {
					height: 30px;
					font-family: DINPro-Medium, DINPro;
					font-weight: bold;
					font-size: 32px;
					line-height: 30px;
					text-align: left;
					letter-spacing: -1px;
				}
				.item-long {
					font-size: 28px;
				}
			}
			&-content {
				flex: 1;
				text-align: left;
				.title {
					height: 18px;
					font-family: PingFangSC, PingFang SC;
					font-weight: bold;
					font-size: 18px;
					line-height: 18px;
					text-align: left;
					font-style: normal;
				}
				.desc {
					height: 12px;
					font-family: PingFangSC, PingFang SC;
					font-size: 12px;
					color: #919199;
					line-height: 12px;
					margin-top: 8px;
				}
			}
			.img-mask {
				opacity: 0.65;
			}
			&-btn {
				width: 86px;
				height: 36px;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 36px;
				border-radius: 24px;
			}
			.left-long {
				padding-left: 12px;
			}
		}
		.prize-big {
			position: relative;
			height: 196px;
			border-radius: 8px;
			padding: 28px 22px;
			&-desc {
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 14px;
				line-height: 14px;
			}
			&-item {
				margin: 4px 0 20px;
				.icon {
					height: 28px;
					font-family: PingFangSC, PingFang SC;
					font-weight: bold;
					font-size: 28px;
					line-height: 28px;
				}
				.item {
					height: 52px;
					font-family: DINPro-Medium, DINPro;
					font-weight: bold;
					font-size: 52px;
					line-height: 52px;
				}
			}
			&-btn {
				width: 100%;
				height: 50px;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 18px;
				color: #FFFFFF;
				line-height: 50px;
				text-align: center;
				border-radius: 24px;
			}
			.img-mask {
				position: relative;
				width: 100%;
				height: 50px;
				opacity: 0.65;
			}
		}
	}
}
.pos-rule {
	position: absolute;
	top: 17px;
	right: 0;
	width: 54px;
	height: 23px;
	background: rgba(255, 240, 230, 0.3);
	border-radius: 11px 0 0 11px;
	line-height: 23px;
	font-size: 13px;
	font-family: PingFang SC;
	color: #ffffff;
}
.pop-box {
	position: fixed;
	z-index: 3;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.8);
	min-height: 100vh;
	.late-pop-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
		height: 100%;
		.late-title {
			width: 118px;
			height: 66px;
			background: url(https://datahub.haohuan.com/gfs/2023-01/62e331a6b8044de1083ac9be35bf274e-8.png);
			background-size: 118px 66px;
		}
		.not-satisfy-title {
			width: 212px;
			background: url(https://datahub.haohuan.com/gfs/2023-01/2ae35eea48e47bca36dd0865901e713f-8.png);
			background-size: 212px 66px;
		}
		.late-content {
			height: 13px;
			font-size: 14px;
			font-family: PingFang SC;
			color: #ffffff;
			margin-top: 22px;
			margin-bottom: 40px;
		}
		.late-close {
			width: 72px;
			height: 28px;
			line-height: 28px;
			border: 1px solid #ffffff;
			border-radius: 14px;
			font-size: 14px;
			font-family: PingFang SC;
			color: #ffffff;
		}
	}
	.rule-pop-box {
		display: flex;
		flex-direction: column;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		position: relative;
		height: 100%;
		.rule-content {
			box-sizing: border-box;
			width: 305px;
			background: #ffffff;
			border-radius: 12px;
			padding: 20px;
			&-title {
				font-size: 16px;
				font-family: PingFang SC;
				font-weight: bold;
				color: #2E2E33;
				margin-bottom: 6px;
			}
			&-content {
				min-height: 24px;
				max-height: 235px;
				font-size: 13px;
				line-height: 24px;
				font-family: DINPro-Regular, DINPro;
				color: #6d6d75;
				text-align: left;
				overflow: scroll;
				-webkit-overflow-scrolling: touch;
				white-space: pre-line; // 识别\n进行换行
				&::-webkit-scrollbar {
					display: none;
				}
			}
			.rule-close {
				padding-top: 20px;
				&-content {
					height: 46px;
					line-height: 46px;
					background: #FF3838;
					border-radius: 23px;
					font-weight: bold;
					font-size: 16px;
					color: #FFFFFF;
					text-align: center;
				}
			}
		}
	}
	.success-pop-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
		height: 100%;
		.success-content {
			width: 336px;
			height: 298px;
			background: url("https://datahub.haohuan.com/gfs/2022-12/11e948767abc1b4812bf05c1124766e3-8.png");
			background-size: 100% 100%;
			padding-top: 31px;
			&-title {
				font-size: 25px;
				font-family: Alibaba PuHuiTi;
				font-weight: bold;
				color: #ffffff;
				text-shadow: 0px 4px 2px rgba(156, 9, 0, 0.11);
				height: 24px;
				line-height: 24px;
			}
			&-content {
				margin-left: 52px;
				margin-top: 17px;
				width: 243px;
				height: 84px;
				background: #ffffff;
				box-shadow: 0px 4px 2px 0px rgba(156, 9, 0, 0.11);
				border-radius: 8px;
				line-height: 84px;
				font-size: 16px;
				font-family: DINPro-Medium, PingFang SC;
				font-weight: 500;
				color: #333333;
				/deep/ span {
					color: #ff4f2f;
					font-size: 17px;
					font-family: DINPro-Medium, DINPro;
					font-weight: 500;
				}
			}
			&-btn {
				margin-left: 52px;
				margin-top: 58px;
				width: 243px;
				height: 50px;
				line-height: 50px;
				background: linear-gradient(0deg, #F3CB74, #FFEDCE);
				box-shadow: 0px 6px 6px 0px rgba(156, 9, 0, 0.23);
				border-radius: 25px;
				font-size: 19px;
				font-family: Alibaba PuHuiTi;
				font-weight: 500;
				color: #9e4f18;
			}
		}
		.success-close {
			margin-top: 27px;
			width: 21px;
			height: 21px;
			background: url("https://datahub.haohuan.com/gfs/2023-01/b7e348f9563dc0d5b86f173ad1aca198-8.png");
			background-size: 21px 21px;
		}
	}
	.obtain-pop-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
		height: 100%;
		.obtain-content {
			width: 295px;
			&-title {
				font-size: 25px;
				font-family: Alibaba PuHuiTi;
				font-weight: bold;
				color: #ffffff;
				text-shadow: 0px 4px 2px rgba(156, 9, 0, 0.11);
				height: 66px;
				padding-top: 31px;
				background: url("https://datahub.haohuan.com/gfs/2024-03/657ab1cb27f98759184804b84f9ddc71-8.png");
				background-size: 100% 100%;
			}
			&-content {
				background: url("https://datahub.haohuan.com/gfs/2024-03/226c30acac3b197969fc533965ff05e7-8.png");
				background-size: 100% 100%;
				padding: 8px 16px 16px 20px;
				margin-top: -1px;
				.prize-small {
					display: flex;
					align-items: center;
					justify-content: flex-start;
					text-align: left;
					padding-left: 10px;
					height: 69px;
					border-radius: 8px;
					width: 260px;
					margin-top: 8px;
					&-left {
						text-align: center;
						width: 92px;
						.icon {
							width: 10px;
							height: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: bold;
							font-size: 13px;
							line-height: 14px;
						}
						.item {
							height: 30px;
							font-family: DINPro-Medium, DINPro;
							font-weight: bold;
							font-size: 30px;
							line-height: 30px;
							text-align: left;
						}
						.item-long {
							font-size: 25px;
							height: 25px;
							line-height: 25px;
						}
					}
					&-content {
						flex: 1;
						.title {
							height: 16px;
							font-family: PingFangSC, PingFang SC;
							font-weight: bold;
							font-size: 16px;
							line-height: 16px;
							color: #2E2E33;
						}
						.desc {
							height: 12px;
							font-family: PingFangSC, PingFang SC;
							font-size: 12px;
							color: #919199;
							line-height: 12px;
							margin-top: 8px;
						}
					}
				}
				.prize-small-word {
					justify-content: center;
					text-align: center;
				}
				.left-world {
					/deep/ span {
						color: #ff4f2f;
						font-size: 17px;
						font-family: DINPro-Medium, DINPro;
						font-weight: 500;
					}
				}
			}
			&-btn {
				padding-left: 18px;
				padding-top: 52px;
				height: 136px;
				background: url("https://datahub.haohuan.com/gfs/2024-03/b4ac701946a212e17b4bcc03ad8507ec-8.png");
				background-size: 100% 100%;
				p {
					width: 261px;
					height: 54px;
					line-height: 54px;
					background: linear-gradient(0deg, #F3CB74, #FFEDCE);
					box-shadow: 0px 6px 6px 0px rgba(156, 9, 0, 0.23);
					border-radius: 25px;
					font-size: 19px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: bold;
					color: #9e4f18;
					.btn-time {
						font-family: DINPro-Medium;
						font-weight: bold;
					}
				}
			}
		}
		.obtain-close {
			margin-top: 27px;
			width: 21px;
			height: 21px;
			background: url("https://datahub.haohuan.com/gfs/2023-01/b7e348f9563dc0d5b86f173ad1aca198-8.png");
			background-size: 21px 21px;
		}
	}
}
</style>